module.exports = __webpack_public_path__ + "static/img/5.582b6c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5/en/btn2/5.jpg
// module id = pxOK
// module chunks = 0